<template>
  <div>
    <p v-if="!isData && complete == true" class="noData">{{lang.infotext_1}}</p>
    <canvas v-if="complete" :id="id" ></canvas>
    <LoaderComponent  v-if="!isData && complete == false"></LoaderComponent>
  </div>
</template>
<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import 'chart.js/dist/Chart.min.js'
import LoaderComponent from "@/components/shared/LoaderComponent"
import Router from 'vue-router'
import * as Tools from './../../Tools/Tools'


export default {
  name: "ChartComponent",
  components:{
      LoaderComponent
  },
  data () {
      return {
        trig: false,
                
      }
  },
  props:{
    data: Array,
    chartType: String,
    lang: Object,
    action: Object,
    complete: Boolean
  },
  computed: {
    id () {
      
      return "chart_" + this._uid;
    },
    isData(){

      
      return this.data.length != 0;

    },
    
    
    
  },
  updated() {
    
    
      //if (this.trig == false){

        this.buildChart();
        this.trig = true
     // }


  },
  created(){
      
  },
  methods: {
    buildChart: function () {

      let vue = this

      let fontColor = "#666666";
      let lineColor = "#cccccc";
      if (this.$store.getters.s_skinVariant == "light"){
        fontColor = "#666666";
        lineColor = "#cccccc";
      }else{
        fontColor = "#f3f3f3";
        lineColor = "#cccccc";
      }

//       if ( this.type == "bar"){


// console.log(this.data)
//       var len = this.data.length;

//       var colors = Tools.getColorChartArray(len, "RGB", 0.9)


// console.log(colors)

//       for (var i = 0, le = this.data[0].datasets.length; i < le; i++){
//         this.data[0].datasets[i].backgroundColor = colors;
//       }

//       var stat = false;
//       if(this.data[0].xAxesLabel != ""){
//         stat = true;
//       }


//       var data = {
//         datasets: this.data[0].datasets,
//         labels: this.data[0].labels
//       }

//         var options = {
//         title: {
//             display: false,
//             text: ''
//         },

//         responsive: true,
//         onClick: function(event, legendItem) {

//           //console.log(event)
//           //console.log(legendItem.length)

//           if (legendItem.length > 0){
//             console.log("filter: "+index + "; item: " + legendItem[0]._index)
//             vue.goTo(index, legendItem[0]._index);
//           }


//           //var clicked = this.getElementAtEvent(event);
//           //console.log("Clicked element: ", clicked);
//         // This chart will not respond to mousemove, etc
//         },
//         legend: {
//           labels: {
//               fontColor: fontColor,
//               //fontSize: 10
//           },
//           display: false
//       },
//       scales: {
//           yAxes: [{
//               ticks: {
//                   fontColor: fontColor,
//                   //fontSize: 10,
//                   //stepSize: 1,
//                   //beginAtZero: true
//               },
//               gridLines: {
//                 display: true,
//                 drawBorder: true,
//                 drawOnChartArea: true,
//                 color: lineColor,
//                 zeroLineColor: lineColor
//               },
//           }],
//           xAxes: [{
//             scaleLabel: {
//               display: stat,
//               labelString: this.data[0].xAxesLabel
//             },
//             ticks: {
//                 fontColor: fontColor,
//                 fontSize: 10,
//                 //beginAtZero: true
//                 autoSkip: false
//             },
//             gridLines: {
//                 display: true,
//                 drawBorder: true,
//                 drawOnChartArea: true,
//                 color: lineColor,
//                 zeroLineColor: lineColor
//               },
//           }]
//       }
//       }


      




//       }

      let chartType = this.chartType;

      if(this.chartType == "stack"){
        chartType = "bar";

        var colors = Tools.getColorChartArray(2, "RGB", 0.9)

        const labels = [];
        const values_yes = [];
        const values_no = [];
        for (let i = 0, lei = this.data.length; i < lei; i++){

          labels.push(this.data[i].category);
          values_yes.push(this.data[i].value_yes);
          values_no.push(this.data[i].value_none);
        }

        
        var data_chart = {
          labels: labels,
          datasets: [
            {
              label: this.lang.legend_Yes,
              data: values_yes,
              backgroundColor: colors[0],
              stack: 'Stack 0',
            },
            {
              label: this.lang.legend_None,
              data: values_no,
              backgroundColor: colors[1],
              stack: 'Stack 0',
            },
            
          ]
        };


        
        var options = {
          title: {
            display: false,
            text: ''
          },
          responsive: true,
          onClick: function(event, legendItem) {

              let index = 1;
                            
              if (legendItem.length > 0){
                
                vue.goTo(index, legendItem[0]._index);
              }

          },
          legend: {
            labels: {
                fontColor: fontColor,
                //defaultFontSize: 5
            }
          },
          scales: {

            xAxes: [{
              stacked: true,
              gridLines: {
                display: false,
                drawBorder: true,
                drawOnChartArea: true,
                color: lineColor,
                zeroLineColor: lineColor
              },
              ticks: {
                fontColor: fontColor,
                fontSize: 10,
                //beginAtZero: true
                autoSkip: false,

              },

            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                display: true,
                drawBorder: true,
                drawOnChartArea: true,
                color: lineColor,
                zeroLineColor: lineColor
              },
              ticks: {
                  fontColor: fontColor,
                  //fontSize: 10,
                  //stepSize: 1,
                  //beginAtZero: true
              },
            }]
          },

        }
      }
        
         
      if( this.chartType == "pie"){

          let len = this.data.length;

          let colors = Tools.getColorChartArray(len, "RGB", 0.9)

          const values = [];
          const labels = [];
          

          for (let i = 0, le = this.data.length; i < le; i++){
            
            values.push(this.data[i].value);
            
            labels.push(this.data[i].category)
            
          }
          
          var data_chart = {
            labels: labels,
            datasets: [{
            label: 'My Dataset',
            data: values,
            backgroundColor: colors,
            hoverOffset: 4
          }]
          };

        let legend = true;
        if (this.data.length > 10) {
          legend = false;
        }

          var options = {
            title: {
              display: false,
              text: ''
            },
            //aspectRatio: 3,
            maintainAspectRatio: false,
            responsive: true,
            maintainAspectRatio: true,
            onClick: function(event, legendItem) {

              let index = 1;
                            
              if (legendItem.length > 0){
                
                vue.goTo(index, legendItem[0]._index);
              }

              
            },
            legend: {
              display: legend,
              labels: {
                  fontColor: fontColor,
                  //defaultFontSize: 5
              }
            },
        }
      }


      let ctx = document.getElementById(this.id).getContext('2d');
      let myChart = new Chart(ctx, {
          type: chartType,
          data: data_chart,
          options: options
      })
      

      Chart.defaults.global.elements.rectangle.color = 'rgba(255, 255, 255, 0.5)';
    },
    goTo: function (filterIndex, chartIndex){
      

      const action = {
        actionId: this.action.actionId,
        name: this.action.name
      }
      
      let to = "";
      let view = "";
      let dispatchAction = "";
      if (this.action.source[0] == "parts"){
        this.$store.dispatch("pm_addActiveAction", action);
        this.$store.dispatch("pm_addActiveFilter", this.action.name);
        to = "/PartManager/PartTable";
        view = "PartTable";
        dispatchAction = "selectTreeItemObject";
      }
      
      if (this.action.source[0] == "libraries"){
        this.$store.dispatch("lm_addActiveAction", action);
        this.$store.dispatch("lm_addActiveFilter", this.action.name);
        to = "/LibraryManager/LibraryTable";
        view = "LibraryTable";
        dispatchAction = "selectTreeLibraryItemObject";
      }

      const  obj = {
        categoryId: this.data[chartIndex].categoryId,
        category: this.data[chartIndex].category,
        name: this.data[chartIndex].category,
        parentId: 0,
        type: 0
      }
      this.$store.dispatch(dispatchAction, obj);
      



      
      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });
    }

        

  }


}
</script>

<style scoped>
  canvas {
			-moz-user-select: none;
			-webkit-user-select: none;
			-ms-user-select: none;

  }
  .noData{
    margin: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ChartComponent.vue